export default {
  label: {
    exportPng: 'Exportar PNG',
  },
};
